<template>
  <div>
    <ContentSectionLoader v-if="!loaded" />
    <Transition name="fade">
      <div v-if="loaded">
        <div class="flex items-center content-center px-2">
          <h2
            v-if="categories.length"
            class="flex-1 m-0"
          >
            Categories
            <span
              v-if="loaded"
              v-text="`(${count})`"
            />
          </h2>
        </div>
        <div
          v-if="loaded && categories.length"
          class="flex flex-row flex-wrap -mx-4"
        >
          <CommunicationCategory
            v-for="category in categories"
            :key="category.uuid"
            :category="category"
          />
        </div>
        <div
          v-if="loaded && !categories.length"
          class="empty mb-4 mx-2"
        >
          <section>
            <h2 v-text="'No results'" />
            <p>It looks like an Organization Admin needs to create some categories.</p>
          </section>
        </div>
      </div>
    </Transition>
    <CategoryModal @update="communicationGetCategories" />
  </div>
</template>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'
import CommunicationCategory from
  'Communication/Resources/assets/js/components/communication-categories/CommunicationCategory'
import CategoryModal
  from 'Communication/Resources/assets/js/components/communication-categories/CommunicationCategoryMembershipGroupModal'

export default {
  name: 'CommunicationCategoryList',
  components: {
    CategoryModal,
    CommunicationCategory,
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapState({
      count: state => state.communication.categories.data.length,
      categories: state => state.communication.categories.data,
    }),
  },
  async mounted() {
    await this.$nextTick()

    this.communicationGetCategories()
      .then(() => {
        this.loaded = true
      })
  },
  methods: {
    ...mapActions([
      'communicationGetCategories',
    ]),
  },
}
</script>
